// extracted by mini-css-extract-plugin
export default {"wrapper":"t-V6+WS","container":"EmV8thf","rating":"OhiDchi"};